import { UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';

const RACHEL_CHATS_KEY = 'rachel-chats';

export const isRachelChatsListQueryKey = (queryKey: readonly unknown[]) =>
  queryKey.includes(RACHEL_CHATS_KEY);

export const getRachelChatsListKey = (search?: string): UseDataQuery['queryKey'] => [
  RACHEL_CHATS_KEY,
  undefined,
  { search: search ?? '' },
];

const RACHEL_CHAT_KEY = 'rachel-chats/:chatId';

export const isRachelChatQueryKey = (queryKey: readonly unknown[], chatId: string) =>
  queryKey.includes(RACHEL_CHAT_KEY) && queryKey.includes(chatId);

export const getRachelChatKey = (chatId: string): UseDataQuery['queryKey'] => [
  RACHEL_CHAT_KEY,
  chatId,
];

export const getRachelChatMessagesKey = (chatId: string): UseDataQuery['queryKey'] => [
  'rachel-chats/:chatId/messages',
  chatId,
];

export const getRachelChatFeedbackKey = (chatId: string): UseDataQuery['queryKey'] => [
  'rachel-chats/:chatId/feedback',
  chatId,
];
